import DataWithLabel from '@lyra/core/components/DataWithLabel'
import ProgressCircle from '@lyra/core/components/ProgressCircle'
import formatPercentage from '@lyra/core/utils/formatPercentage'
import {
  MARGIN_UTIL_CRITICAL_THRESHOLD,
  MARGIN_UTIL_WARNING_THRESHOLD,
} from '@lyra/web/constants/position'

type Props = {
  marginUtilization: number
  label?: string
  tooltipContent?: React.ReactNode
  isSmall?: boolean
}

export default function MarginUsageDataWithLabel({
  marginUtilization,
  label,
  tooltipContent,
  isSmall,
}: Props) {
  return (
    <DataWithLabel
      label={label ?? 'Margin Usage'}
      value={formatPercentage(marginUtilization)}
      tooltipContent={tooltipContent}
      isSmall={isSmall}
      rightContent={
        <ProgressCircle
          size={isSmall ? 16 : 20}
          percentComplete={marginUtilization}
          color={
            marginUtilization > MARGIN_UTIL_CRITICAL_THRESHOLD
              ? 'red'
              : marginUtilization > MARGIN_UTIL_WARNING_THRESHOLD
              ? 'amber'
              : 'green'
          }
        />
      }
    />
  )
}
